/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/*
    JavaScript autoComplete v1.0.4
    Copyright (c) 2014 Simon Steinberger / Pixabay
    GitHub: https://github.com/Pixabay/JavaScript-autoComplete
    License: http://www.opensource.org/licenses/mit-license.php
*/

const AutoComplete = options => {
  if (!document.querySelector) return;

  // helpers
  function hasClass(el, className) {
    return el.classList
      ? el.classList.contains(className)
      : new RegExp(`\\b${className}\\b`).test(el.className);
  }

  function addEvent(el, type, handler) {
    if (el.attachEvent) el.attachEvent(`on${type}`, handler);
    else el.addEventListener(type, handler);
  }
  function removeEvent(el, type, handler) {
    // if (el.removeEventListener) not working in IE11
    if (el.detachEvent) el.detachEvent(`on${type}`, handler);
    else el.removeEventListener(type, handler);
  }
  function live(elClass, event, cb, context) {
    addEvent(context || document, event, e => {
      let found;
      let el = e.target || e.srcElement;
      // eslint-disable-next-line no-cond-assign
      while (el && !(found = hasClass(el, elClass))) el = el.parentElement;
      if (found) cb.call(el, e);
    });
  }

  const o = {
    selector: 0,
    source: 0,
    minChars: 3,
    delay: 150,
    offsetLeft: 0,
    offsetTop: 1,
    cache: 1,
    menuClass: '',
    renderItem(item, search) {
      // escape special characters
      // eslint-disable-next-line no-param-reassign
      search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const re = new RegExp(`(${search.split(' ').join('|')})`, 'gi');
      return `<div class="autocomplete-suggestion" data-val="${item}">${item.replace(
        re,
        '<b>$1</b>',
      )}</div>`;
    },
    onSelect(e, term, item) {},
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const k in options) {
    // eslint-disable-next-line no-prototype-builtins
    if (options.hasOwnProperty(k)) o[k] = options[k];
  }

  // init
  const elems =
    typeof o.selector === 'object'
      ? [o.selector]
      : document.querySelectorAll(o.selector);
  for (let i = 0; i < elems.length; i += 1) {
    const that = elems[i];

    // create suggestions container "sc"
    that.sc = document.createElement('div');
    that.sc.className = `autocomplete-suggestions ${o.menuClass}`;

    that.autocompleteAttr = that.getAttribute('autocomplete');
    that.setAttribute('autocomplete', 'off');
    that.cache = {};
    that.last_val = '';

    that.updateSC = (resize, next) => {
      const rect = that.getBoundingClientRect();
      that.sc.style.left = `${Math.round(
        rect.left +
          (window.pageXOffset || document.documentElement.scrollLeft) +
          o.offsetLeft,
      )}px`;
      that.sc.style.top = `${Math.round(
        rect.bottom +
          (window.pageYOffset || document.documentElement.scrollTop) +
          o.offsetTop,
      )}px`;
      that.sc.style.width = `${Math.round(rect.right - rect.left)}px`; // outerWidth
      if (!resize) {
        that.sc.style.display = 'block';
        if (!that.sc.maxHeight) {
          that.sc.maxHeight = parseInt(
            (window.getComputedStyle
              ? getComputedStyle(that.sc, null)
              : that.sc.currentStyle
            ).maxHeight,
            10,
          );
        }
        if (!that.sc.suggestionHeight)
          that.sc.suggestionHeight = that.sc.querySelector(
            '.autocomplete-suggestion',
          ).offsetHeight;
        if (that.sc.suggestionHeight)
          if (!next) that.sc.scrollTop = 0;
          else {
            const scrTop = that.sc.scrollTop;
            const selTop =
              next.getBoundingClientRect().top -
              that.sc.getBoundingClientRect().top;
            if (selTop + that.sc.suggestionHeight - that.sc.maxHeight > 0)
              that.sc.scrollTop =
                selTop + that.sc.suggestionHeight + scrTop - that.sc.maxHeight;
            else if (selTop < 0) that.sc.scrollTop = selTop + scrTop;
          }
      }
    };
    addEvent(window, 'resize', that.updateSC);
    document.body.appendChild(that.sc);

    live(
      'autocomplete-suggestion',
      'mouseleave',
      e => {
        const sel = that.sc.querySelector('.autocomplete-suggestion.selected');
        if (sel)
          setTimeout(() => {
            sel.className = sel.className.replace('selected', '');
          }, 20);
      },
      that.sc,
    );

    live(
      'autocomplete-suggestion',
      'mouseover',
      e => {
        const sel = that.sc.querySelector('.autocomplete-suggestion.selected');
        if (sel) sel.className = sel.className.replace('selected', '');
        const el = e.target || e.srcElement;
        el.className += ' selected';
      },
      that.sc,
    );

    live(
      'autocomplete-suggestion',
      'mousedown',
      e => {
        const el = e.target || e.srcElement;
        if (hasClass(el, 'autocomplete-suggestion')) {
          // else outside click
          const v = el.getAttribute('data-val');
          that.value = v;
          o.onSelect(e, v, el);
          that.sc.style.display = 'none';
        }
      },
      that.sc,
    );

    that.blurHandler = () => {
      let overSb = 0;
      try {
        overSb = document.querySelector('.autocomplete-suggestions:hover');
      } catch (e) {
        overSb = 0;
      }
      if (!overSb) {
        that.last_val = that.value;
        that.sc.style.display = 'none';
        setTimeout(() => {
          that.sc.style.display = 'none';
        }, 350); // hide suggestions on fast input
      } else if (that !== document.activeElement)
        setTimeout(() => {
          that.focus();
        }, 20);
    };
    addEvent(that, 'blur', that.blurHandler);

    const suggest = data => {
      const val = that.value;
      that.cache[val] = data;
      if (data.length && val.length >= o.minChars) {
        let s = '';
        for (let j = 0; j < data.length; j += 1)
          s += o.renderItem(data[j], val);
        that.sc.innerHTML = s;
        that.updateSC(0);
      } else that.sc.style.display = 'none';
    };

    that.keydownHandler = e => {
      const key = window.event ? e.keyCode : e.which;
      // down (40), up (38)
      if ((key === 40 || key === 38) && that.sc.innerHTML) {
        let next;
        const sel = that.sc.querySelector('.autocomplete-suggestion.selected');
        if (!sel) {
          next =
            key === 40
              ? that.sc.querySelector('.autocomplete-suggestion')
              : that.sc.childNodes[that.sc.childNodes.length - 1]; // first : last
          next.className += ' selected';
          that.value = next.getAttribute('data-val');
        } else {
          next = key === 40 ? sel.nextSibling : sel.previousSibling;
          if (next) {
            sel.className = sel.className.replace('selected', '');
            next.className += ' selected';
            that.value = next.getAttribute('data-val');
          } else {
            sel.className = sel.className.replace('selected', '');
            that.value = that.last_val;
            next = 0;
          }
        }
        that.updateSC(0, next);
        return false;
      }
      // esc
      if (key === 27) {
        that.value = that.last_val;
        that.sc.style.display = 'none';
      }
      // enter
      else if (key === 13 || key === 9) {
        const sel = that.sc.querySelector('.autocomplete-suggestion.selected');
        if (sel && that.sc.style.display !== 'none') {
          o.onSelect(e, sel.getAttribute('data-val'), sel);
          setTimeout(() => {
            that.sc.style.display = 'none';
          }, 20);
        }
      }
      return true;
    };
    addEvent(that, 'keydown', that.keydownHandler);

    that.keyupHandler = e => {
      const key = window.event ? e.keyCode : e.which;
      if (!key || ((key < 35 || key > 40) && key !== 13 && key !== 27)) {
        const val = that.value;
        if (val.length >= o.minChars) {
          if (val !== that.last_val) {
            that.last_val = val;
            clearTimeout(that.timer);
            if (o.cache) {
              if (val in that.cache) {
                suggest(that.cache[val]);
                return;
              }
              // no requests if previous suggestions were empty
              for (let k = 1; k < val.length - o.minChars; k += 1) {
                const part = val.slice(0, val.length - k);
                if (part in that.cache && !that.cache[part].length) {
                  suggest([]);
                  return;
                }
              }
            }
            that.timer = setTimeout(() => {
              o.source(val, suggest);
            }, o.delay);
          }
        } else {
          that.last_val = val;
          that.sc.style.display = 'none';
        }
      }
    };
    addEvent(that, 'keyup', that.keyupHandler);

    that.focusHandler = e => {
      that.last_val = '\n';
      that.keyupHandler(e);
    };
    if (!o.minChars) addEvent(that, 'focus', that.focusHandler);
  }

  // public destroy method
  this.destroy = () => {
    for (let i = 0; i < elems.length; i += 1) {
      let that = elems[i];
      removeEvent(window, 'resize', that.updateSC);
      removeEvent(that, 'blur', that.blurHandler);
      removeEvent(that, 'focus', that.focusHandler);
      removeEvent(that, 'keydown', that.keydownHandler);
      removeEvent(that, 'keyup', that.keyupHandler);
      if (that.autocompleteAttr)
        that.setAttribute('autocomplete', that.autocompleteAttr);
      else that.removeAttribute('autocomplete');
      document.body.removeChild(that.sc);
      that = null;
    }
  };
};
export default AutoComplete;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/autocomplete.js